var Library = (function () {
    function Library(query, dom) {
        if (query === void 0) { query = null; }
        if (dom === void 0) { dom = null; }
        this.domWrapper = {
            extend: function (object1, object2) { return $.extend(object1, object2); },
            find: function (selector) { return $(selector); }
        };
        this.myQuery = query || $;
        this.myDom = dom || this.domWrapper;
    }
    Object.defineProperty(Library.prototype, "query", {
        get: function () {
            return this.myQuery;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Library.prototype, "dom", {
        get: function () {
            return this.myDom;
        },
        enumerable: false,
        configurable: true
    });
    return Library;
}());
export { Library };
